import type { FormInputItem } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/types';
import { FC, memo } from 'react';

type DefaultFieldViewProps = {
  item: FormInputItem;
};

export const DefaultFieldView: FC<DefaultFieldViewProps> = memo(({ item }) => {
  return <div>{item?.input_values?.[0]?.label ?? ''}</div>;
});

DefaultFieldView.displayName = 'DefaultFieldView';
